function BookVector() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			fill="none"
			viewBox="0 0 14 14"
		>
			<g clipPath="url(#clip0_3614:9905)">
				<path
					fill="#DA4A54"
					d="M12.75 0v11.49L2.506 12.609l-1.255.137V1.255A1.25 1.25 0 012.507 0h10.242z"
				></path>
				<path
					fill="#C32430"
					d="M2.507 0v12.608l-1.255.137V1.255A1.25 1.25 0 012.507 0z"
				></path>
				<path
					fill="#C32430"
					d="M12.748 11.49H2.506a1.255 1.255 0 000 2.51h10.243v-.705l-.51-.55.51-.55v-.705z"
				></path>
				<path
					fill="#DFEAEF"
					d="M2.505 13.296a.551.551 0 010-1.1h10.243v1.1H2.505z"
				></path>
				<path
					fill="#F4DD45"
					d="M5.77 2.72l-.913-.936-.912.936V0H5.77v2.72z"
				></path>
				<path
					fill="#DFEAEF"
					d="M9.746 3.506H4.882a.883.883 0 00-.883.883v2.694c0 .488.395.883.883.883h4.864a.883.883 0 00.883-.883V4.389a.883.883 0 00-.883-.883z"
				></path>
				<path
					fill="#C32430"
					d="M9.746 8.178H4.882c-.603 0-1.094-.491-1.094-1.095V4.39c0-.603.491-1.094 1.094-1.094h4.864c.603 0 1.094.49 1.094 1.094v2.694c0 .604-.49 1.095-1.094 1.095zm-4.864-4.46a.672.672 0 00-.671.671v2.694c0 .37.301.672.671.672h4.864c.37 0 .672-.301.672-.672V4.39a.673.673 0 00-.672-.672H4.882z"
				></path>
				<path
					fill="#665E66"
					d="M9.298 5.387H5.33a.211.211 0 010-.422H9.3a.211.211 0 010 .422zM9.298 6.506H5.33a.211.211 0 010-.422H9.3a.211.211 0 010 .423z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_3614:9905">
					<path fill="#fff" d="M0 0H14V14H0z"></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default BookVector;
